import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { IPerformanceBodWaterDisposal } from 'src/app/api/performance-bod-water-disposal';
import { IEditableInline } from 'src/app/api/ieditable-inline';
import { InlineEditService } from 'src/app/services/inline-edit.service';
import { PerformanceBodDataService } from 'src/app/services/performance-bod-data.service';
import * as Helpers from 'src/app/_shared/helpers';

@Injectable({
  providedIn: 'root',
})
export class PerformanceBodWaterDisposalService extends InlineEditService implements IEditableInline {
  public data: IPerformanceBodWaterDisposal[] = [];
  public originalData: IPerformanceBodWaterDisposal[] = [];
  public createdItems: IPerformanceBodWaterDisposal[] = [];
  public updatedItems: IPerformanceBodWaterDisposal[] = [];
  public deletedItems: IPerformanceBodWaterDisposal[] = [];
  public performanceBodId: string;

  constructor(
    private performanceBodDataService: PerformanceBodDataService
  ) {
    super();
  }

  public isNew(item: any): boolean {
    return !item.id;
  }

  public itemIndex(item: any, data: IPerformanceBodWaterDisposal[]): number {
    for (let idx = 0; idx < data.length; idx++) {
      if (data[idx].id === item.id) {
        return idx;
      }
    }
    return -1;
  }

  public create(): Observable<any> {
    return this.performanceBodDataService.createPerformanceBodWaterDisposal(this.createdItems);
  }

  public retrieve(): Observable<any> {
    return     this.performanceBodDataService.getPerformanceBodWaterDisposal(this.performanceBodId).pipe(map(data => {
      data.forEach(element => {
        if (element.readyForServiceDate !== null && element.readyForServiceDate !== undefined) {
          element.readyForServiceDate = Helpers.convertUtcToLocalTime(element.readyForServiceDate);
        } else {
          element.readyForServiceDate = undefined;
        }
      });
      return data;
    }));
  }

  public update(): Observable<any> {
    return this.performanceBodDataService.updatePerformanceBodWaterDisposal(this.updatedItems);
  }

  public delete(): Observable<any> {
    return this.performanceBodDataService.updatePerformanceBodWaterDisposal(this.deletedItems);
  }

  public validateRangeNumberValue(value: number): boolean {
    if (value >= 0 && value <= 1000000) {
      return true;
    } else {
      return false;
    }
  }
}
